(function () {
  // Only run on the homepage
  if (!document.body.classList.contains('template-index')) return;

  var STYLE = "" +
    ".rs-stats-counter{display:flex;flex-wrap:nowrap;justify-content:center;align-items:flex-start;gap:48px;padding:32px 16px;background-color:#fbf4e4;margin:0 auto;box-sizing:border-box;}" +
    ".rs-stat{text-align:center;flex:1 1 0;min-width:0;display:flex;flex-direction:column;align-items:center;justify-content:flex-start;}" +
    ".rs-stat-number{width:100%;text-align:center;font-size:42px;font-weight:800;color:#1a1a1a;line-height:1;display:flex;align-items:center;justify-content:center;gap:4px;}" +
    ".rs-stat-number .rs-suffix{font-size:32px;}" +
    ".rs-stat-icon{width:100%;text-align:center;font-size:22px;color:#f3be53;margin-bottom:4px;}" +
    ".rs-stat-label{width:100%;text-align:center;margin-top:8px;font-size:14px;font-weight:600;color:#5a4f3f;text-transform:uppercase;letter-spacing:0.5px;}" +
    "@media (max-width:767px){" +
      ".rs-stats-counter{flex-wrap:wrap;gap:20px 12px;padding:24px 12px;justify-content:center;}" +
      ".rs-stat{flex:0 0 calc(50% - 12px);max-width:calc(50% - 12px);align-items:center;}" +
      ".rs-stat-number{font-size:28px;}" +
      ".rs-stat-number .rs-suffix{font-size:20px;}" +
      ".rs-stat-icon{font-size:16px;}" +
      ".rs-stat-label{font-size:11px;}" +
    "}";

  var HTML = '' +
    '<div class="rs-stats-counter" id="rsStatsCounter">' +
      '<div class="rs-stat">' +
        '<div class="rs-stat-icon">\u2605\u2605\u2605\u2605\u2605</div>' +
        '<div class="rs-stat-number"><span class="rs-count" data-target="155">0</span></div>' +
        '<div class="rs-stat-label">Google Reviews</div>' +
      '</div>' +
      '<div class="rs-stat">' +
        '<div class="rs-stat-icon">\uD83C\uDF7D\uFE0F</div>' +
        '<div class="rs-stat-number"><span class="rs-count" data-target="1850">0</span><span class="rs-suffix">+</span></div>' +
        '<div class="rs-stat-label">Catering Orders Fulfilled</div>' +
      '</div>' +
      '<div class="rs-stat">' +
        '<div class="rs-stat-icon">\uD83E\uDD6A</div>' +
        '<div class="rs-stat-number"><span class="rs-count" data-target="68">0</span></div>' +
        '<div class="rs-stat-label">Products</div>' +
      '</div>' +
      '<div class="rs-stat">' +
        '<div class="rs-stat-icon">\uD83D\uDCC5</div>' +
        '<div class="rs-stat-number"><span class="rs-count" data-target="6">0</span></div>' +
        '<div class="rs-stat-label">Years Servicing Melbourne</div>' +
      '</div>' +
    '</div>';

  function injectStyle() {
    var styleEl = document.createElement('style');
    styleEl.textContent = STYLE;
    document.head.appendChild(styleEl);
  }

  function animateCount(node) {
    var target = parseInt(node.getAttribute('data-target'), 10);
    var duration = 1500;
    var startTime = null;
    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      node.textContent = Math.floor(eased * target).toLocaleString();
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        node.textContent = target.toLocaleString();
      }
    }
    requestAnimationFrame(step);
  }

  function startCounters(container) {
    var counts = container.querySelectorAll('.rs-count');
    counts.forEach(animateCount);
  }

  function findTrustedBySection() {
    var candidates = document.querySelectorAll('body *');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el.children.length === 0 && el.textContent && /TRUSTED\s*BY/i.test(el.textContent)) {
        var section = el.closest('.shopify-section');
        if (section) return section;
      }
    }
    return null;
  }

  function init() {
    var trustedBySection = findTrustedBySection();
    if (!trustedBySection) return;

    injectStyle();
    trustedBySection.insertAdjacentHTML('afterend', HTML);

    var container = document.getElementById('rsStatsCounter');
    if (!container) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            startCounters(container);
            observer.disconnect();
          }
        });
      }, { threshold: 0.4 });
      observer.observe(container);
    } else {
      startCounters(container);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
